<button type="button" class="btn btn-primary btn-round" (click)="clicked()">
    <span inlineSVG="/assets/svg/circle-arrow.svg"></span> {{ text }}
  </button>
  
  